// import other possible components here
import PackageDetails from "@/Views/ExportJob/CreateNewJob/ContainerTab/PackageDetails";
import SummaryPopover from "@/Components/Dialog/SummaryPopover";
import ImportHighSeaSeller from "@/Views/ImportJob/CreateNewJob/General/ImportHighSeaSeller";
import Container from "@/Views/ImportJob/CreateNewJob/ShipmentTab/Container";
import InvoiceQuickEntry from "@/Views/ExportJob/CreateNewJob/InvoiceTab/InvoiceQuickEntry";
import ProductReExportInit from "@/Views/ExportJob/CreateNewJob/Product/ProductRe-ExportInitDialog";
import BankSelectorPopover from "@/Views/ExportJob/CreateNewJob/BankSelectorPopover";
import DBKBankList from "../Views/ExportJob/CreateNewJob/DBKBankList";
import OpenSubDialogWrapper from "../Views/ExportJob/CreateNewCustomer/OpenSubDialogWrapper";
import UploadRemoveDialog from "../Views/ExportJob/CreateNewCustomer/OpenSubDialogWrapper";
import ShipmentExBondInitPopUp from "@/Views/ExportJob/CreateNewJob/ShipmentExBond/ShipmentExBondInitPopUp";
import MisCharge from "../Views/ImportJob/CreateNewJob/MisCharge"
import ProductDeclaration from "@/Views/ExportJob/CreateNewJob/Product/ProductDeclaration";
import SpecialPermission from "../Views/ImportJob/CreateNewJob/General/SpecialPermission";
import ActiveDialog from "@/Components/Dialog/ActiveDialog";
import Tracking from "../Views/ExportJob/CreateNewJob/Tracking";
import InvoiceDeclaration from "@/Views/ImportJob/CreateNewJob/Invoice/InvoiceDeclaration";
import ImportProductDeclaration from "@/Views/ImportJob/CreateNewJob/Product/ImportProductDeclaration";
import ProductReImportInit from "@/Views/ImportJob/CreateNewJob/Product/ProductRe-ImportInit";

export const dynamicComponentMap = {
  PackageDetails,
  SummaryPopover,
  ImportHighSeaSeller,
  Container,
  InvoiceQuickEntry,
  ProductReExportInit,
  BankSelectorPopover,
  DBKBankList,
  UploadRemoveDialog,
  ShipmentExBondInitPopUp,
  MisCharge,
  ProductDeclaration,
  SpecialPermission,
  ActiveDialog,
  Tracking,
  InvoiceDeclaration,
  ImportProductDeclaration,
  ProductReImportInit
  // Add other sub-dialog components here
};
  